import React, { useState, useEffect } from "react";
import "./EmojiSuduko.css";

const easyEmojis = ["🍎","🍌","🍇","🍉"];
const hardEmojis = ["🚀","🎮","📚","🎵","⚽","🏀"];

function generateGrid(size) {
  return Array(size).fill(null).map(() => Array(size).fill(""));
}

const EmojiSuduko = () => {
  const [mode, setMode] = useState("easy");
  const size = mode === "easy" ? 4 : 6;
  const emojis = mode === "easy" ? easyEmojis : hardEmojis;
  const [grid, setGrid] = useState(generateGrid(size));
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  useEffect(() => {
    setGrid(generateGrid(size));
    setScore(0);
    setTime(0);
    setGameOver(false);
    setMessage("");
  }, [mode]);

  useEffect(() => {
    let timer;
    if (!gameOver) {
      timer = setInterval(() => setTime((t) => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [gameOver]);

  const handleChange = (row, col, emoji) => {
    const newGrid = [...grid.map(r => [...r])];
    newGrid[row][col] = emoji;
    setGrid(newGrid);
    validateSudoku(newGrid);
  };

  const validateSudoku = (grid) => {
    // Row & column validation
    for (let i = 0; i < size; i++) {
      const rowSet = new Set(grid[i].filter(Boolean));
      if (rowSet.size !== grid[i].filter(Boolean).length) {
        setMessage("⚠️ Duplicate in row " + (i+1));
        setScore(score - 2);
        wrongSound.play();
        return;
      }
      const colSet = new Set(grid.map(r => r[i]).filter(Boolean));
      if (colSet.size !== grid.map(r => r[i]).filter(Boolean).length) {
        setMessage("⚠️ Duplicate in column " + (i+1));
        setScore(score - 2);
        wrongSound.play();
        return;
      }
    }

    // Block validation
    const blockRows = mode === "easy" ? 2 : 3;
    const blockCols = mode === "easy" ? 2 : 2;
    for (let r = 0; r < size; r += blockRows) {
      for (let c = 0; c < size; c += blockCols) {
        let block = [];
        for (let i = 0; i < blockRows; i++) {
          for (let j = 0; j < blockCols; j++) {
            block.push(grid[r+i][c+j]);
          }
        }
        const blockSet = new Set(block.filter(Boolean));
        if (blockSet.size !== block.filter(Boolean).length) {
          setMessage("⚠️ Duplicate in block ("+(r+1)+","+(c+1)+")");
          setScore(score - 2);
          wrongSound.play();
          return;
        }
      }
    }

    // Success check
    if (grid.every(row => row.every(cell => cell !== ""))) {
      setMessage("🎉 Sudoku solved! Final Score: " + score);
      setGameOver(true);
      winSound.play();
    } else {
      setMessage("✅ Good move! Keep going!");
      setScore(score + 5);
      correctSound.play();
    }
  };

  return (
    <div className="sudoku-container">
      <h1>🔢 Emoji Sudoku</h1>
      <div className="mode-buttons">
        <button onClick={() => {setMode("easy");}}>Under 12</button>
        <button onClick={() => {setMode("hard");}}>Above 12</button>
      </div>
      <div className="stats">
        <p>⏱ Time: {time}s</p>
        <p>⭐ Score: {score}</p>
      </div>
      <div className="sudoku-grid" style={{gridTemplateColumns: `repeat(${size}, 1fr)`}}>
        {grid.map((row, rIndex) =>
          row.map((cell, cIndex) => (
            <select
              key={`${rIndex}-${cIndex}`}
              value={cell}
              onChange={(e) => handleChange(rIndex, cIndex, e.target.value)}
              className="sudoku-cell"
            >
              <option value="">⬜</option>
              {emojis.map((emoji, i) => (
                <option key={i} value={emoji}>{emoji}</option>
              ))}
            </select>
          ))
        )}
      </div>
      <p className="status">{message}</p>
    </div>
  );
};

export default EmojiSuduko;
